import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-placeholder",
  "use": "icon-m-placeholder-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-placeholder\"><path d=\"M40 0v40H0V0zm-2 2H2v36h36zm-6.23 4c.326 0 .637.139.854.382.501.51.501 1.324 0 1.833L21.71 20l10.914 11.785c.501.509.501 1.324 0 1.833a1.146 1.146 0 0 1-1.71 0L20 21.833 9.085 33.618a1.146 1.146 0 0 1-1.71 0 1.305 1.305 0 0 1 0-1.833L18.29 20 7.376 8.215a1.305 1.305 0 0 1 0-1.833 1.146 1.146 0 0 1 1.71 0L20 18.167 30.915 6.382c.217-.243.528-.382.854-.382\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol